import createReducer from '../../utils/createReducer';
import {
  FETCH_LEGACY_ORDERS_SUCCESS,
  FETCH_LEGACY_ORDERS_ERROR,
} from '../../actions/legacyOrders/legacyOrderActionConstants';

const initialState = {
  legacyOrders: [],
  errorMessage: '',
};

export default createReducer(
  {
    [FETCH_LEGACY_ORDERS_SUCCESS]: setLegacyOrders,
    [FETCH_LEGACY_ORDERS_ERROR]: setLegacyOrdersError,
  },
  initialState,
);

function setLegacyOrders(state, action) {
  return {
    ...state,
    legacyOrders: action.payload,
    error: '',
  };
}

function setLegacyOrdersError(state, action) {
  return {
    ...state,
    error: action.payload,
  };
}
